import React, { memo } from 'react';
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinus } from '@fortawesome/free-solid-svg-icons';
import Select from '../../../components/Select/Select';
import MultiSelect from '../../../components/Select/MultiSelect';
import Input from '../../../components/Input/Input';
import Button from '../../../components/Button/Button';

const TimeTableForm = ({ changeHandler, submitHandler, id,
  classAddHandler, classRemoveHandler, programData, subjectData,
  program_ids, data, addRow, clickOnDelete, DAYS_OF_WEEK }) => {

  return (
    <Form onSubmit={submitHandler}>
      <div className="col-md-12">
        <Form.Group>
          <Form.Label>Class</Form.Label>
          <MultiSelect
            name={`program_ids`}
            options={programData}
            id={program_ids}
            onRemove={(e) => classRemoveHandler(e)}
            onChangeHandler={(e) => classAddHandler(e)}
            displayValue="name"
            selectedValues={program_ids}
            closeOnSelect={false}
            placeholder="Select Class"
          />
        </Form.Group>
      </div>
      {data && data.map((val, idx) => {
        return (
          <div className="row mt-2 syllbus" key={idx}>
            <div className={"col-md-6"}>
              <Select
                label="Subject"
                name="subject_id"
                id="subject_id"
                value={val.subject_id}
                onChangeHandler={(e) => changeHandler(e, idx)}
                options={subjectData}
                placeholder="Select Subject"
                required={true}
              />
            </div>
            <div className={"col-md-6"}>
              <Select
                label="Day"
                name="day"
                id="day"
                value={val.day}
                onChangeHandler={(e) => changeHandler(e, idx)}
                options={DAYS_OF_WEEK}
                placeholder="Select Day"
                required={true}
              />
            </div>
            <div className={"col-md-6"}>
              <Input
                label="Start Time"
                type="time"
                name="start_time"
                value={val.start_time}
                onChangeHandler={(e) => changeHandler(e, idx)}
                required={true}
              />
            </div>
            <div className={id ? "col-md-6" : "col-md-5"}>
              <Input
                label="End Time"
                type="time"
                name="end_time"
                value={val.end_time}
                onChangeHandler={(e) => changeHandler(e, idx)}
                required={true}
              />
            </div>
            {!id &&
              <div className="col-md-1">
                {
                  idx === 0 ? <Button variant="primary" onClick={addRow} type="button"
                    className="text-center mt-4">
                    <FontAwesomeIcon icon={faPlusCircle} />
                  </Button>
                    : <Button type="submit" variant="danger" className="mt-4"
                      onClick={(e) => clickOnDelete(e, val)} >
                      <FontAwesomeIcon icon={faMinus} />
                    </Button>
                }
              </div>
            }
          </div>
        )
      })}
      <div className="row d-flex justify-content-end mt-3">
        <div className="col-md-1">
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default memo(TimeTableForm);
